
import React from 'react';
import { StatsCard } from '@/components/dashboard/StatsCard';
import { Banknote, ZapOff, Clock, Rocket } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface StatsCardsProps {
  stats: {
    totalTokens: number;
    estimatedCost: number;
    avgResponseTime: number;
    cacheHitRate: number;
    totalRequests: number;
  };
  isLoading: boolean;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ stats, isLoading }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[0, 1, 2, 3].map(i => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    );
  }
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatsCard
        title="Total Tokens"
        value={stats.totalTokens.toLocaleString()}
        icon={<Rocket className="h-5 w-5 text-primary" />}
      />
      <StatsCard
        title="Estimated Cost"
        value={`$${stats.estimatedCost.toFixed(2)}`}
        icon={<Banknote className="h-5 w-5 text-primary" />}
      />
      <StatsCard
        title="Avg. Response Time"
        value={`${stats.avgResponseTime.toFixed(0)}ms`}
        icon={<Clock className="h-5 w-5 text-primary" />}
      />
      <StatsCard
        title="Cache Hit Rate"
        value={`${stats.cacheHitRate.toFixed(1)}%`}
        icon={<ZapOff className="h-5 w-5 text-primary" />}
        change={stats.cacheHitRate > 50 ? "Efficient" : "Room to improve"}
        positive={stats.cacheHitRate > 50}
      />
    </div>
  );
};
